import { render, staticRenderFns } from "./SampleValueColumn.vue?vue&type=template&id=281dcdd9&scoped=true&"
import script from "./SampleValueColumn.vue?vue&type=script&lang=js&"
export * from "./SampleValueColumn.vue?vue&type=script&lang=js&"
import style0 from "./SampleValueColumn.vue?vue&type=style&index=0&id=281dcdd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281dcdd9",
  null
  
)

export default component.exports